import React from 'react';
import clsx from 'clsx';
import styles from './ContractInfoCard.module.css';

export interface ContractInfoCardProps {
  contractNumber: string;
  contractName: string;
  className?: string;
}

const ContractInfoCard: React.FC<ContractInfoCardProps> = ({
  contractNumber,
  contractName,
  className
}) => {
  return (
    <div className={clsx(styles.contractInfo, className)}>
      <strong>{contractNumber}</strong>
      <span className={styles.contractName}>{contractName}</span>
    </div>
  );
};

export default ContractInfoCard;
